import React from 'react';
import { useIntl } from 'react-intl';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import DynamicEmailConfirmationAlert
  from '../components/Users/DynamicEmailConfirmationAlert';
import Head from '../components/Head';
import Hero from '../components/Hero';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import DashboardLayout from '../components/Dashboard/Layout/Dynamic';
import { useSiteContext } from '../components/SiteContext';

const DynamicProfile = dynamic(() => import('../components/Users/Profile'), {
  ssr: false,
  loading,
});

const ProfilePage = () => {
  const intl = useIntl();

  return (
    <>
      <Head
        title={intl.formatMessage(messages.profile)}
        description={intl.formatMessage(messages['markets.description'])}
      />
      <DynamicProfile />
    </>
  );
};

const LayoutComponent = ({ children }) => {
  const { dashboard } = useSiteContext();

  return dashboard ? (
    <DashboardLayout>
      {children}
    </DashboardLayout>
  ) : (
    <Layout
      header={<Hero />}
      sitewideAlert={
        <DynamicEmailConfirmationAlert marginBottom={(136 / 2) + 24} />
    }
    >
      {children}
    </Layout>
  );
};

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

ProfilePage.getLayout = (page) => <LayoutComponent>{page}</LayoutComponent>;

export default withApollo(ProfilePage);
